module.exports = __webpack_public_path__ + "static/media/onza_thumb.1682d332.jpg";